(function() {
  function initConceptoInmersivo(root) {
    if (!root || root.dataset.conceptoInmersivoInitialized === 'true') return;

    root.dataset.conceptoInmersivoInitialized = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-concept-button]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-concept-panel]'));
    var activeConcept = root.getAttribute('data-active-concept') || 'estructura';
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!buttons.length || !panels.length) return;

    function setActiveConcept(conceptName) {
      if (!conceptName) return;

      activeConcept = conceptName;
      root.setAttribute('data-active-concept', conceptName);

      buttons.forEach(function(button) {
        var isActive = button.getAttribute('data-concept-button') === conceptName;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      panels.forEach(function(panel) {
        var isActive = panel.getAttribute('data-concept-panel') === conceptName;

        panel.classList.toggle('is-active', isActive);
      });
    }

    buttons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        setActiveConcept(button.getAttribute('data-concept-button'));
      });

      button.addEventListener('mouseenter', function() {
        if (!canHover) return;
        setActiveConcept(button.getAttribute('data-concept-button'));
      });

      button.addEventListener('focus', function() {
        if (!canHover) return;
        setActiveConcept(button.getAttribute('data-concept-button'));
      });
    });

    setActiveConcept(activeConcept);
  }

  function initAllConceptoInmersivo() {
    var roots = document.querySelectorAll('.js-concepto-inmersivo');

    roots.forEach(function(root) {
      initConceptoInmersivo(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllConceptoInmersivo);
  } else {
    initAllConceptoInmersivo();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('.js-concepto-inmersivo');

    if (root) {
      root.dataset.conceptoInmersivoInitialized = 'false';
      initConceptoInmersivo(root);
    }
  });
})();